import { UserAuthWrapper } from 'redux-auth-wrapper';
import {
    loadingBinderSelector,
} from 'common/permissions/selectors';
import { uploadDocumentPredicate } from 'common/permissions/studyPredicates';

export const UserCanUploadFilesByDragAndDrop = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingBinderSelector,
    predicate: uploadDocumentPredicate,
    FailureComponent: (props) => <span>{props.children}</span>
});
